<script>
import {mapState, mapMutations} from 'vuex';
import TriviaService from "@/api/services/triviaService";
import DepService from "@/api/services/depService";

export default {
  name: 'EndScreenView',
  computed: {
    ...mapState(['user', 'productId', 'categoryGameState', 'gameState', 'userStats', 'isFreeUser']),

    totalCorrect() {
      return parseInt(this.$route.query.correct) || 0;
    },

    totalQuestions() {
      return parseInt(this.$route.query.total) || 7;
    },

    coinsEarned() {
      const coins = parseInt(this.$route.query.coins) || (this.totalCorrect * 10);
      console.log('💰 EndScreen - Coins:', coins);
      return coins;
    },
    shouldShowBonusButton() {
      if (this.gameState?.IsRandomize) return true;
      if (!this.categoryGameState || !Array.isArray(this.categoryGameState)) return false;
      const category44Complete = this.categoryGameState.some(cat =>
          cat.QuestionCategoryId === 44 && cat.CategoryComplete === 1
      );
      const category46Complete = this.categoryGameState.some(cat =>
          cat.QuestionCategoryId === 46 && cat.CategoryComplete === 1
      );
      return category44Complete && category46Complete;
    }
  },
  methods: {
    ...mapMutations(['setGameState', 'setUserStats','setRegularGameCoins']),
    async getUserStats() {
      const recordsets = await TriviaService.getUserStats(this.user.msisdn, this.productId, this.user.serviceId);
      this.setUserStats(recordsets?.[0]?.[0])
    },
    async playBonusRound() {
      this.setRegularGameCoins(this.coinsEarned);
      console.log('💰 Storing coins for bonus:', this.coinsEarned);
      this.$router.push({name: 'bonus-round'});
    },

    async returnHome() {
      await this.addFunds(this.coinsEarned);
      await this.getUserStats();
      this.$router.push('/');
    },
    subscribeMtnClicked() {
      this.$router.push('/upgrade-package')
    },
    async addFunds(amount) {
      try {
        await DepService.addFunds(
            this.user.msisdn,
            this.productId,
            7,
            1,
            amount,
            this.gameState.GameId
        );
        console.log('Coins added:', amount);
      } catch (error) {
        console.error('Error adding coins:', error);
      }
    }
  },
  async mounted() {
  }
}

</script>

<template>
  <div class="d-flex flex-column justify-content-center align-items-center col-12 mt-4">
    <div class="col-12 text-center" style="font-size: 30px; font-weight: 600">Congratulations</div>
    <div class="col-12 text-center" style="font-size: 17px; font-weight: 300">You scored{{ totalCorrect }}/{{ totalQuestions }}
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center col-12">
      <img src="@/assets/gameplay/end-screen-img.png" class="col-7"/>
    </div>
    <div class="d-flex flex-column justify-content-center align-items-center col-12 position-relative">
      <img src="@/assets/gameplay/coin-sparkles.png" class="col-5"/>
      <div class="d-flex justify-content-center align-items-center col-8" style="position: absolute; top: 14%">
        <div class="coins-text text-center col-5">+{{ coinsEarned }}</div>
        <img src="@/assets/gameplay/coins-medium.png" class="col-3" alt="">
      </div>
    </div>
    <div v-if="this.isFreeUser" @click="this.$router.push('/upgrade')"
         class="col-11 text-center fw-bold play-bonus-btn p-4 mt-4">
      Upgrade to Keep Playing
    </div>
    <div v-else-if="shouldShowBonusButton" class="col-11 text-center fw-bold play-bonus-btn p-4 mt-4" @click="playBonusRound">
      Play Bonus Round
    </div>
    <div v-if="this.isFreeUser" @click="subscribeMtnClicked()"
         class="d-flex flex-column justify-content-center align-items-center col-12 mt-4">
      <img src="@/assets/home/vip-pass.png" class="col-11"/>
    </div>
    <div @click="returnHome()" class="col-11 text-center return-home fw-bold mt-5">
      Return Home
    </div>
  </div>
</template>


<style scoped>
.return-home {
  color: #000;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}

.play-bonus-btn {
  font-size: 18px;
  border-radius: 29px;
  background: #FFCB05;
}

.coins-text {
  color: #000F56;
  text-align: center;
  leading-trim: both;
  text-edge: cap;
  font-size: 47px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.2px;
  text-transform: uppercase;
}
</style>